<div class="flex-container" style="height: 100%">
  <vl-widget-title
    [text]="'stats.stock_actuel' | trans"
    [widget]="widget()"
    [draggable]="false"
    [editable]="false"
  >
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>
  </vl-widget-title>

  @if (metadata()?.loading) {
    <div class="widget-content h100 overflow-hidden">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
              height: '136px',
              'background-color': 'var(--color-on-disabled)',
            }"
      />
    </div>
  } @else {
    <vl-lot-stock-summary
      [lots]="stats()?.lots"
      [articleId]="articleId()"
    />
  }
</div>
